<template>
  <div class="pop">
    <div class="cover" v-if="showCover"></div>
    <div class="popup" v-if="showCover">
      <div>
        <div class="close" @click="closePop()">
          <img alt="xxx" src="@/assets/skoda-drive/imgs/106.png" style="width: 100%;" />
        </div>

        <div class="img">
          <video style="width:100%" muted autoplay="autoplay" loop="loop" controls="controls">
            <source :src="videoUrl" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["showCover", "videoUrl", "closePop"],
  name: "popup",
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
.cover {
  position: fixed;
  /*首先将位置固定住*/
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /*上下左右设置都为0*/
  background: rgba(2, 2, 2, 0.7);
  z-index: 10;
}
.popup {
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 12%;
  bottom: 0;
  width: 60%;
  z-index: 11;
}
.popup .close {
  position: relative;
  float: right;
  width: 20px;
  cursor: pointer;
}
</style>